export default __webpack_public_path__ + "static/media/target-4@3x.144cffe4.png";